<template>
  <thead>
    <tr>
      <th
        v-for="(header, index) in headers"
        class="overview-table-column left-column-border"
        :key="index"
      >
        {{ header.title }}
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: 'OverviewTable',
  data: () => ({
    headers: [
      { title: 'Dike Profile' },
      { title: 'Schematisation' },
      { title: 'Stage' },
      { title: 'Year' },
      { title: 'Stage configuration revision' },
      { title: 'Soil type revision' },
      { title: 'Water line rule revision' },
      { title: 'Created by' },
      { title: 'Reviewed by' },
      { title: 'Overtopping' },
      { title: 'Start reinforcement' },
      { title: 'X location' },
      { title: 'Soil type' },
      { title: 'Continue slope' },
      { title: 'Z crest' },
      { title: 'W crest' },
      { title: 'Outer slope' },
      { title: 'Inner slope' },
      { title: 'Z berm' },
      { title: 'W berm' },
      { title: 'Slope berm' },
      { title: 'Z berm' },
      { title: 'B berm' },
      { title: 'Slope berm' }
    ]
  })
}
</script>

<style>
.overview-table-column {
  min-width: 100px;
}
.left-column-border {
  border-left: solid 1px #f5f5f5;
}
</style>
